<div *ngIf="isPageReady" class="flex flex-col gap-4 p-4">
  <div class="text-lg font-semibold border-b pb-2">Confirm Product Substitution</div>

  <p>
    The item you scanned is a different product than what was ordered. If you apply it,
    the physical item you're shipping will not match the ordered product. The customer's
    order and invoice will still show the originally ordered product.
  </p>

  <table class="qb-info-table w-full">
    <tr>
      <td class="label font-semibold pr-4 py-1">Order asked for:</td>
      <td class="value py-1">{{ expectedLabel }}</td>
    </tr>
    <tr>
      <td class="label font-semibold pr-4 py-1">You're using:</td>
      <td class="value py-1">{{ actualLabel }}</td>
    </tr>
  </table>

  <p class="italic text-sm">
    Do you want to continue?
  </p>

  <div class="flex justify-end gap-2 mt-2">
    <button pButton type="button" class="p-button-text" (click)="onCancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="onOk()">
      <span>Yes, apply the substitute</span>
    </button>
  </div>
</div>
